var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowedMarker = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 39,
    viewBox: "0 0 26 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 33.5C5.01099 33.9632 3 34.8291 3 35.8208C3 37.3005 7.47715 38.5 13 38.5C18.5228 38.5 23 37.3005 23 35.8208C23 34.8855 21.2111 34.0621 18.5 33.5828",
    stroke: "#ED4C3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 0C9.55219 0 6.24558 1.36437 3.80761 3.79297C1.36964 6.22156 0 9.51545 0 12.95C0 19.8246 4.64286 23.125 8.35714 29.6C12.0714 36.075 12.0714 37 13 37C13.9286 37 13.9286 36.075 17.6429 29.6C21.3571 23.125 26 19.4741 26 12.95C26 9.51545 24.6304 6.22156 22.1924 3.79297C19.7544 1.36437 16.4478 0 13 0Z",
    fill: "#ED4C3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M5.57153 15.111H9.69852V6.85706H16.3017V15.111H20.4287L13.0001 22.5396L5.57153 15.111Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M4.46042 4.4483C6.72465 2.19278 9.79636 0.925 13 0.925C16.2036 0.925 19.2753 2.19278 21.5396 4.4483C23.8037 6.7037 25.075 9.76192 25.075 12.95C25.075 15.9631 24.0133 18.3305 22.4353 20.7946C21.8161 21.7615 21.1308 22.7238 20.4009 23.7485C20.1909 24.0434 19.9772 24.3435 19.7603 24.6503C18.7978 26.012 17.7911 27.4826 16.8405 29.1397C15.5464 31.3957 14.6808 33.0188 14.09 34.1266C13.8364 34.6021 13.6334 34.9826 13.4689 35.2776C13.2307 35.7047 13.0896 35.9213 13 36.0332C12.9104 35.9213 12.7693 35.7047 12.5311 35.2776C12.3666 34.9826 12.1636 34.6021 11.91 34.1266C11.3192 33.0188 10.4536 31.3957 9.1595 29.1397C8.20693 27.4791 7.19824 26.0282 6.23454 24.6924C6.00221 24.3703 5.77377 24.0566 5.54975 23.749C4.83589 22.7688 4.167 21.8503 3.5607 20.9199C1.99127 18.5113 0.925 16.1436 0.925 12.95C0.925 9.76192 2.19631 6.7037 4.46042 4.4483Z",
    stroke: "black",
    strokeWidth: 1.85
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowedMarker);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ArrowedMarker.f6222e2e18dc9d2df93603b00d7438ab.svg";